var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41667 10.1543H8.25V11.9876H6.41667V10.1543ZM19.25 5.57096V18.4043C19.25 19.4126 18.425 20.2376 17.4167 20.2376H4.58333C3.56583 20.2376 2.75 19.4126 2.75 18.4043L2.75917 5.57096C2.75917 4.56263 3.56583 3.73763 4.58333 3.73763H5.5V1.9043H7.33333V3.73763H14.6667V1.9043H16.5V3.73763H17.4167C18.425 3.73763 19.25 4.56263 19.25 5.57096ZM4.58333 7.4043H17.4167V5.57096H4.58333V7.4043ZM17.4167 18.4043V9.23763H4.58333V18.4043H17.4167ZM13.75 11.9876H15.5833V10.1543H13.75V11.9876ZM10.0833 11.9876H11.9167V10.1543H10.0833V11.9876Z",
    fill: "#4A4A4A",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/Date.c060d9e0a6a473c410a6301e050fd377.svg";
export { ForwardRef as ReactComponent };